import { EntityType, SlugMappingResponse } from '@chilipiper/api-type-def'
import { nanoid } from 'nanoid'
import { fireApiGet } from './api'

export const firerouterService = {
  mapping(
    domain: string,
    entityType: EntityType,
    legacySlug: string
  ): Promise<SlugMappingResponse> {
    return fireApiGet(
      `api/firerouter/v1/slug-mapping-by-legacy-by-subdomain/${domain}/${entityType}/${legacySlug}`,
      {
        headers: {
          'x-request-id': nanoid(),
          'x-caller-ref': `guest/${nanoid()}`,
        },
      }
    )
      .json<SlugMappingResponse | undefined>()
      .then(response => {
        if (!response) {
          return Promise.resolve({
            fireSlug: legacySlug,
            entityType,
            legacySlug,
          })
        }
        return Promise.resolve(response)
      })
      .catch(err => {
        console.error(err)
        return {
          fireSlug: legacySlug,
          entityType,
          legacySlug,
        } as SlugMappingResponse
      })
  },
  mappingByLegacyId(
    domain: string,
    entityType: EntityType,
    legacyId: string
  ): Promise<SlugMappingResponse> {
    return fireApiGet(
      `api/firerouter/v1/slug-mapping-by-legacy-id-by-subdomain/${domain}/${entityType}/${legacyId}`,
      {
        headers: {
          'x-request-id': nanoid(),
          'x-caller-ref': `guest/${nanoid()}`,
        },
      }
    )
      .json<SlugMappingResponse | undefined>()
      .then(response => {
        if (!response) {
          return Promise.resolve({
            entityFireId: legacyId,
            fireSlug: legacyId,
            entityType,
            entityLegacyId: legacyId,
            legacySlug: legacyId,
          })
        }
        return Promise.resolve(response)
      })
      .catch(err => {
        console.error(err)
        return {
          entityFireId: legacyId,
          fireSlug: legacyId,
          entityType,
          entityLegacyId: legacyId,
          legacySlug: legacyId,
        } as SlugMappingResponse
      })
  },
}
